// conversationRows — the author's conversations projected to list rows, pure.
//
// ONE projection for both doors to a conversation (the sidebar's recent list
// and the chat panel's picker), so the two never drift in order, title
// fallback, timestamp or active state.

export { conversationRowsOf };

import type { RecentThread } from "../../components/WorkspaceLanding/WorkspaceLanding.js";
import { formatRecency } from "../recency.js";

type ConversationRow = {
    readonly id: string;
    readonly title: string;
    readonly when?: string;
    // The last activity (ISO 8601), for sorting by last changed.
    readonly changedAt?: string;
    readonly active: boolean;
    readonly archived: boolean;
};

// Newest activity first; a thread with no recorded activity sorts last (ISO
// 8601 UTC compares chronologically as text, and "" sorts below any instant).
const conversationRowsOf = (
    summaries: readonly RecentThread[],
    activeId: string | null,
    nowMs: number,
    locale: string,
    untitled: string,
): readonly ConversationRow[] =>
    [...summaries]
        .sort((a, b) =>
            (b.lastActivityAt ?? "").localeCompare(a.lastActivityAt ?? ""),
        )
        .map((c) => ({
            id: c.id,
            title: c.title || untitled,
            when: c.lastActivityAt
                ? formatRecency(c.lastActivityAt, nowMs, locale)?.relative
                : undefined,
            changedAt: c.lastActivityAt,
            active: c.id === activeId,
            archived: c.archived === true,
        }));
